import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
`;

export const ItemTitle = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
`;

export const ItemDescription = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const CheckboxDescriptionContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 20px;
`;

export const CheckboxHeader = styled.div<{ $disabled?: boolean }>`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) =>
    props.$disabled
      ? props.theme.atlas.semantic.color.type.disabled
      : props.theme.atlas.semantic.color.type.default};
  margin-bottom: 4px;
`;

export const CheckboxDescription = styled.div<{ $disabled?: boolean }>`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) =>
    props.$disabled
      ? props.theme.atlas.semantic.color.type.disabled
      : props.theme.atlas.semantic.color.type.default};
`;
